// Dependencies
import React from 'react';
import PropTypes from 'prop-types';

// Styles
import BlogAuthorSocialStyles from './blogAuthorSocial.styles';

export default function BlogAuthorSocial({ author, compact }) {
  const firstName = author?.firstName;
  const blogProfile = author?.blogProfile;

  const facebook = blogProfile?.facebookProfileUrl;
  const twitter = blogProfile?.twitterProfileUrl;
  const linkedin = blogProfile?.linkedinProfileUrl;
  const instagram = blogProfile?.instagramProfileUrl;
  const britishPsychologicalSociety =
    blogProfile?.britishPsychologicalSocietyUrl;

  return (
    <BlogAuthorSocialStyles compact={compact}>
      <ul>
        {twitter && (
          <li className="twitter">
            <a
              href={twitter}
              target="_blank"
              rel="noreferrer"
              aria-label={`${firstName ? `${firstName}'s ` : ''}X profile`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                fill="#A0988F"
                className="icon"
              >
                <path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm297.1 84L257.3 234.6 379.4 396H283.8L209 298.1 123.3 396H75.8l111-126.9L69.7 116h98l67.7 89.5L313.6 116h47.5zM323.3 367.6L153.4 142.9H125.1L296.9 367.6h26.3z" />
              </svg>
            </a>
          </li>
        )}

        {facebook && (
          <li className="facebook">
            <a
              href={facebook}
              target="_blank"
              rel="noreferrer"
              aria-label={`${
                firstName ? `${firstName}'s ` : ''
              }Facebook profile`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                fill="#A0988F"
                className="icon"
              >
                <path d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z" />
              </svg>
            </a>
          </li>
        )}

        {instagram && (
          <li className="instagram">
            <a
              href={instagram}
              target="_blank"
              rel="noreferrer"
              aria-label={`${
                firstName ? `${firstName}'s ` : ''
              }Instagram profile`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                fill="#A0988F"
                className="icon"
              >
                <path d="M224,202.66A53.34,53.34,0,1,0,277.36,256,53.38,53.38,0,0,0,224,202.66Zm124.71-41a54,54,0,0,0-30.41-30.41c-21-8.29-71-6.43-94.3-6.43s-73.25-1.93-94.31,6.43a54,54,0,0,0-30.41,30.41c-8.28,21-6.43,71.05-6.43,94.33S91,329.26,99.32,350.33a54,54,0,0,0,30.41,30.41c21,8.29,71,6.43,94.31,6.43s73.24,1.93,94.3-6.43a54,54,0,0,0,30.41-30.41c8.35-21,6.43-71.05,6.43-94.33S357.1,182.74,348.75,161.67ZM224,338a82,82,0,1,1,82-82A81.9,81.9,0,0,1,224,338Zm85.38-148.3a19.14,19.14,0,1,1,19.13-19.14A19.1,19.1,0,0,1,309.42,189.74ZM400,32H48A48,48,0,0,0,0,80V432a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V80A48,48,0,0,0,400,32ZM382.88,322c-1.29,25.63-7.14,48.34-25.85,67s-41.4,24.63-67,25.85c-26.41,1.49-105.59,1.49-132,0-25.63-1.29-48.26-7.15-67-25.85s-24.63-41.42-25.85-67c-1.49-26.42-1.49-105.61,0-132,1.29-25.63,7.07-48.34,25.85-67s41.47-24.56,67-25.78c26.41-1.49,105.59-1.49,132,0,25.63,1.29,48.33,7.15,67,25.85s24.63,41.42,25.85,67.05C384.37,216.44,384.37,295.56,382.88,322Z" />
              </svg>
            </a>
          </li>
        )}

        {linkedin && (
          <li className="linkedin">
            <a
              href={linkedin}
              target="_blank"
              rel="noreferrer"
              aria-label={`${
                firstName ? `${firstName}'s ` : ''
              }LinkedIn profile`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                fill="#A0988F"
                className="icon"
              >
                <path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z" />
              </svg>
            </a>
          </li>
        )}

        {britishPsychologicalSociety && !compact && (
          <li className="british-psychological-society">
            <a
              href={britishPsychologicalSociety}
              target="_blank"
              rel="noreferrer"
              aria-label={`${
                firstName ? `${firstName}'s ` : ''
              }British Psychological Society profile`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 199.3 40.3"
                fill="#a0988f"
                className="icon british-psychological-society"
              >
                <path
                  className="a"
                  d="M7.7,14.3a3.67,3.67,0,0,1-2.7.9,2.64,2.64,0,0,1-2.9-2.8V6.1H0V4.7H2.1V2.2l1.7-.5V4.6H7.6V6H3.8v6.1a1.4,1.4,0,0,0,1.6,1.5,2.5,2.5,0,0,0,1.8-.8Z"
                />
                <path
                  className="a"
                  d="M18.8,8.4V15H17.1V9c0-2.3-1.1-3.1-2.5-3.1s-3.2,1-3.2,3.6V15H9.7V0h1.7V6.3a3.81,3.81,0,0,1,3.4-1.8A3.7,3.7,0,0,1,18.8,8.4Z"
                />
                <path
                  className="a"
                  d="M30.3,10.5H22.5a3.28,3.28,0,0,0,3.4,3.3c1.5,0,2.5-.5,2.9-1.5l1.4.7a4.51,4.51,0,0,1-4.3,2.3c-3.1,0-5-2-5-5.4s1.8-5.4,4.9-5.4,4.6,2.2,4.6,4.8C30.4,9.8,30.3,10.2,30.3,10.5ZM22.5,9h6.3c-.2-1.9-1.3-3.1-3-3.1A3.29,3.29,0,0,0,22.5,9Z"
                />
                <path
                  className="a"
                  d="M48.8,9.9c0,3.4-1.8,5.4-4.7,5.4a3.8,3.8,0,0,1-3.5-2l-.1,1.8H39.1V0h1.7V6.4a3.79,3.79,0,0,1,3.4-1.8C46.9,4.5,48.8,6.5,48.8,9.9Zm-1.7,0c0-2.4-1.2-3.9-3.2-3.9s-3.2,1.5-3.2,3.8V10c0,2.3,1.3,3.8,3.2,3.8S47.1,12.3,47.1,9.9Z"
                />
                <path
                  className="a"
                  d="M57,4.7l-.3,1.6A2.5,2.5,0,0,0,55.4,6c-1.2,0-2.7,1.1-2.7,3.4V15H51V4.7h1.3l.2,1.7a3.27,3.27,0,0,1,3.3-1.9A4.3,4.3,0,0,1,57,4.7Z"
                />
                <path
                  className="a"
                  d="M58.4,1.5a1.2,1.2,0,0,1,2.4,0,1.2,1.2,0,0,1-2.4,0Zm2.1,13.6H58.8V4.7h1.7Z"
                />
                <path
                  className="a"
                  d="M70,14.3a3.67,3.67,0,0,1-2.7.9,2.64,2.64,0,0,1-2.9-2.8V6.1h-2V4.7h2.1V2.2l1.7-.5V4.6H70V6H66.2v6.1a1.4,1.4,0,0,0,1.6,1.5,2.5,2.5,0,0,0,1.8-.8Z"
                />
                <path
                  className="a"
                  d="M71.3,1.5a1.2,1.2,0,0,1,2.4,0,1.2,1.2,0,0,1-2.4,0Zm2.1,13.6H71.7V4.7h1.7Z"
                />
                <path
                  className="a"
                  d="M75.5,12.9l1.3-.9c.5,1.3,1.8,1.8,3.3,1.8,1.7,0,2.5-.7,2.5-1.5s-.6-1.2-2.7-1.6c-2.9-.5-4-1.3-4-3.1S77.5,4.5,80,4.5c2.2,0,3.5.8,4.1,2.5l-1.4.8A2.56,2.56,0,0,0,80,5.9c-1.4,0-2.4.7-2.4,1.5s.7,1.3,2.8,1.7c2.9.5,3.9,1.3,3.9,3s-1.7,3.1-4.3,3.1A4.6,4.6,0,0,1,75.5,12.9Z"
                />
                <path
                  className="a"
                  d="M95.6,8.4V15H93.9V9c0-2.3-1.1-3.1-2.5-3.1s-3.2,1-3.2,3.6V15H86.5V0h1.7V6.3a3.81,3.81,0,0,1,3.4-1.8A3.7,3.7,0,0,1,95.6,8.4Z"
                />
                <path
                  className="a"
                  d="M11.2,30.7c0,3.4-1.8,5.4-4.7,5.4a3.68,3.68,0,0,1-3.4-1.8v6H1.4V25.5H2.8l.1,1.8a3.8,3.8,0,0,1,3.5-2C9.3,25.3,11.2,27.3,11.2,30.7Zm-1.7,0c0-2.4-1.2-3.9-3.2-3.9s-3.2,1.5-3.2,3.8v.2c0,2.3,1.3,3.8,3.2,3.8S9.5,33.1,9.5,30.7Z"
                />
                <path
                  className="a"
                  d="M12.7,33.7l1.3-.9c.5,1.3,1.8,1.8,3.3,1.8,1.7,0,2.5-.7,2.5-1.5s-.6-1.2-2.7-1.6c-2.9-.5-4-1.3-4-3.1s1.6-3.1,4.1-3.1c2.2,0,3.5.8,4.1,2.5l-1.5.8a2.56,2.56,0,0,0-2.7-1.9c-1.4,0-2.4.7-2.4,1.5s.7,1.3,2.8,1.7c2.9.5,3.9,1.3,3.9,3S19.7,36,17.1,36C15.2,36,13.4,35.3,12.7,33.7Z"
                />
                <path
                  className="a"
                  d="M27.7,37.6c-.8,2-1.7,2.7-3.3,2.7a2.7,2.7,0,0,1-2.3-.9l.6-1.4a1.86,1.86,0,0,0,1.7.8c.7,0,1.4-.3,1.9-1.7l.5-1.3L22.5,25.5h1.9L27,32.2l.6,1.8.7-2,2.4-6.5h1.8Z"
                />
                <path
                  className="a"
                  d="M42.4,28l-1.6.7a2.64,2.64,0,0,0-2.8-2c-2.1,0-3.3,1.5-3.3,3.9s1.2,3.9,3.3,3.9a2.69,2.69,0,0,0,2.9-2.1l1.5.5a4.37,4.37,0,0,1-4.4,3c-3.1,0-5-2-5-5.4s1.9-5.4,5-5.4A5,5,0,0,1,42.4,28Z"
                />
                <path
                  className="a"
                  d="M53.6,29.2v6.6H51.9v-6c0-2.3-1.1-3.1-2.5-3.1s-3.2,1-3.2,3.6v5.5H44.5V20.7h1.7V27a3.81,3.81,0,0,1,3.4-1.8C51.8,25.3,53.6,26.5,53.6,29.2Z"
                />
                <path
                  className="a"
                  d="M65.9,30.7c0,3.3-1.9,5.4-5,5.4s-5-2-5-5.4,1.9-5.4,5-5.4S65.9,27.3,65.9,30.7Zm-8.3,0c0,2.5,1.3,3.9,3.3,3.9s3.3-1.5,3.3-3.9-1.3-3.9-3.3-3.9S57.6,28.2,57.6,30.7Z"
                />
                <path
                  className="a"
                  d="M69.9,33.1c0,1.1.3,1.4,1.1,1.4a4,4,0,0,0,1.5-.3l-.3,1.6a3.65,3.65,0,0,1-1.5.3c-1.7,0-2.5-.9-2.5-2.8V20.7h1.7Z"
                />
                <path
                  className="a"
                  d="M83.1,30.7c0,3.3-1.9,5.4-5,5.4s-5-2-5-5.4,1.9-5.4,5-5.4S83.1,27.3,83.1,30.7Zm-8.3,0c0,2.5,1.3,3.9,3.3,3.9s3.3-1.5,3.3-3.9-1.3-3.9-3.3-3.9S74.8,28.2,74.8,30.7Z"
                />
                <path
                  className="a"
                  d="M94.4,37c0,2-2.3,3.3-5.1,3.3-3.3,0-4.8-1.2-4.8-2.7a2.11,2.11,0,0,1,1.8-2,2.15,2.15,0,0,1-1.4-1.9,2,2,0,0,1,1.6-2A3.11,3.11,0,0,1,85,28.9c0-2,1.8-3.5,4.2-3.5a4.64,4.64,0,0,1,2.1.4,2.74,2.74,0,0,1,2.9-2.1l.4,1.4c-1.4,0-2.2.4-2.5,1.1a3.17,3.17,0,0,1,1.3,2.6c0,2-1.8,3.5-4.2,3.5a7.77,7.77,0,0,1-1.6-.2c-.8.2-1.2.6-1.2,1.3s.6,1.1,1.4,1.1h3.4C93.2,34.5,94.4,35.5,94.4,37Zm-1.5.1c0-.7-.5-1.2-2-1.2H88.1c-1.3,0-2,.5-2,1.3,0,1,1.1,1.7,3.4,1.7S92.9,38.1,92.9,37.1Zm-6.2-8.3a2.52,2.52,0,0,0,5,0,2.23,2.23,0,0,0-2.5-2.1A2.17,2.17,0,0,0,86.7,28.8Z"
                />
                <path
                  className="a"
                  d="M95.9,22.3a1.2,1.2,0,1,1,1.2,1.2A1.16,1.16,0,0,1,95.9,22.3ZM98,35.8H96.4V25.5h1.7V35.8Z"
                />
                <path
                  className="a"
                  d="M109.7,28l-1.6.7a2.64,2.64,0,0,0-2.8-2c-2.1,0-3.3,1.5-3.3,3.9s1.2,3.9,3.3,3.9a2.69,2.69,0,0,0,2.9-2.1l1.5.5a4.37,4.37,0,0,1-4.4,3c-3.1,0-5-2-5-5.4s1.9-5.4,5-5.4A5,5,0,0,1,109.7,28Z"
                />
                <path
                  className="a"
                  d="M121.2,34.5l-.1,1.3a3.73,3.73,0,0,1-1.2.2,1.69,1.69,0,0,1-1.9-1.5,4,4,0,0,1-3.3,1.5c-1.9,0-3.5-.9-3.5-2.8,0-1.6,1.4-2.8,4-3.2l2.8-.5v-.6a2.18,2.18,0,0,0-2.4-2.3,3.13,3.13,0,0,0-3,2l-1.2-.9a4.24,4.24,0,0,1,4.2-2.5c2.4,0,4.1,1.1,4.1,3.5v5.1c0,.5.2.7.8.7A.85.85,0,0,0,121.2,34.5Zm-3.3-2.2V30.9l-2.3.4c-1.8.3-2.8.9-2.8,1.9s.7,1.3,1.9,1.3C116.4,34.6,117.9,33.7,117.9,32.3Z"
                />
                <path
                  className="a"
                  d="M124.4,33.1c0,1.1.3,1.4,1.1,1.4a4,4,0,0,0,1.5-.3l-.3,1.6a3.65,3.65,0,0,1-1.5.3c-1.7,0-2.5-.9-2.5-2.8V20.7h1.7Z"
                />
                <path
                  className="a"
                  d="M132.9,33.7l1.3-.9c.5,1.3,1.8,1.8,3.3,1.8,1.7,0,2.5-.7,2.5-1.5s-.6-1.2-2.7-1.6c-2.9-.5-4-1.3-4-3.1s1.6-3.1,4.1-3.1c2.2,0,3.5.8,4.1,2.5l-1.4.8a2.56,2.56,0,0,0-2.7-1.9c-1.4,0-2.4.7-2.4,1.5s.7,1.3,2.8,1.7c2.9.5,3.9,1.3,3.9,3S140,36,137.4,36A4.78,4.78,0,0,1,132.9,33.7Z"
                />
                <path
                  className="a"
                  d="M153.3,30.7c0,3.3-1.9,5.4-5,5.4s-5-2-5-5.4,1.9-5.4,5-5.4S153.3,27.3,153.3,30.7Zm-8.3,0c0,2.5,1.3,3.9,3.3,3.9s3.3-1.5,3.3-3.9-1.3-3.9-3.3-3.9S145,28.2,145,30.7Z"
                />
                <path
                  className="a"
                  d="M164.4,28l-1.6.7a2.64,2.64,0,0,0-2.8-2c-2.1,0-3.3,1.5-3.3,3.9s1.2,3.9,3.3,3.9a2.69,2.69,0,0,0,2.9-2.1l1.5.5a4.37,4.37,0,0,1-4.4,3c-3.1,0-5-2-5-5.4s1.9-5.4,5-5.4A5,5,0,0,1,164.4,28Z"
                />
                <path
                  className="a"
                  d="M166.2,22.3a1.2,1.2,0,1,1,1.2,1.2A1.16,1.16,0,0,1,166.2,22.3Zm2,13.5h-1.7V25.5h1.7Z"
                />
                <path
                  className="a"
                  d="M180,31.3h-7.8a3.28,3.28,0,0,0,3.4,3.3c1.5,0,2.5-.5,2.9-1.5l1.4.7a4.51,4.51,0,0,1-4.3,2.3c-3.1,0-5-2-5-5.4s1.8-5.4,4.9-5.4,4.6,2.2,4.6,4.8A4.12,4.12,0,0,1,180,31.3Zm-7.7-1.5h6.3c-.2-1.9-1.3-3.1-3-3.1A3.16,3.16,0,0,0,172.3,29.8Z"
                />
                <path
                  className="a"
                  d="M188.6,35.1a3.67,3.67,0,0,1-2.7.9,2.64,2.64,0,0,1-2.9-2.8V26.9h-2.1V25.5H183V23l1.7-.5v2.9h3.8v1.4h-3.8v6.1a1.4,1.4,0,0,0,1.6,1.5,2.5,2.5,0,0,0,1.8-.8Z"
                />
                <path
                  className="a"
                  d="M194.5,37.6c-.8,2-1.7,2.7-3.3,2.7a2.7,2.7,0,0,1-2.3-.9l.6-1.4a1.86,1.86,0,0,0,1.7.8c.7,0,1.4-.3,1.9-1.7l.5-1.3-4.3-10.3h1.9l2.6,6.7.6,1.8.7-2,2.4-6.5h1.8Z"
                />
              </svg>
            </a>
          </li>
        )}
      </ul>
    </BlogAuthorSocialStyles>
  );
}

BlogAuthorSocial.propTypes = {
  author: PropTypes.shape({
    firstName: PropTypes.string,
    blogProfile: PropTypes.shape({
      facebookProfileUrl: PropTypes.string,
      twitterProfileUrl: PropTypes.string,
      linkedinProfileUrl: PropTypes.string,
      instagramProfileUrl: PropTypes.string,
      britishPsychologicalSocietyUrl: PropTypes.string,
    }),
  }).isRequired,
  compact: PropTypes.bool,
};

BlogAuthorSocial.defaultProps = {
  compact: false,
};
